'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _Checkbox = require('./Checkbox.style');

var _FieldWrapper = require('../FieldWrapper/FieldWrapper');

var _FieldWrapper2 = _interopRequireDefault(_FieldWrapper);

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Basic checkbox input.
 */
var Checkbox = function Checkbox(_ref) {
  var checkedComponent = _ref.checkedComponent,
      className = _ref.className,
      description = _ref.description,
      disabled = _ref.disabled,
      error = _ref.error,
      focused = _ref.focused,
      label = _ref.label,
      name = _ref.name,
      onSwitch = _ref.onSwitch,
      uncheckedComponent = _ref.uncheckedComponent,
      switched = _ref.switched,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['checkedComponent', 'className', 'description', 'disabled', 'error', 'focused', 'label', 'name', 'onSwitch', 'uncheckedComponent', 'switched']);
  return _react2.default.createElement(
    _FieldWrapper2.default,
    {
      description: description,
      error: error,
      labelFor: name
    },
    _react2.default.createElement(
      'div',
      (0, _extends3.default)({
        className: 'checkbox ' + className + ' ' + (disabled ? 'disabled' : ''),
        onClick: onSwitch
      }, rest),
      _react2.default.createElement(
        'div',
        { className: 'check ' + (switched ? 'checked' : 'unchecked') },
        _react2.default.createElement(
          'div',
          { className: 'checkbox-checked' },
          checkedComponent
        ),
        _react2.default.createElement(
          'div',
          { className: 'checkbox-unchecked' },
          uncheckedComponent
        )
      ),
      label &&
      // eslint-disable-next-line
      _react2.default.createElement(
        'label',
        { htmlFor: label },
        label
      )
    )
  );
};

exports.Checkbox = Checkbox;
Checkbox.propTypes = {
  /**
   * Component to display when checked
   */
  checkedComponent: _propTypes2.default.node,
  /**
   * className for glamorous styles
   * @ignore
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Set true to default checked.
   */
  defaultValue: _propTypes2.default.bool,
  /**
   * Helper description for tooltip
   */
  description: _propTypes2.default.string,
  /**
   * Whether checkbox is disabled or not.
   * onSwitch, onChange and onClick will not fire if disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Error message for input. Alters input style and displays error message if set.
   */
  error: _propTypes2.default.string,
  /**
   * Field label text to display above input
   */
  label: _propTypes2.default.string,
  /**
   * Field name in form
   */
  name: _propTypes2.default.string,
  /**
   * Function to call on input blur
   */
  onBlur: _propTypes2.default.func,
  /**
   * Function to call on input change
   */
  onChange: _propTypes2.default.func,
  /**
   * Function to call when when switched.
   * Also fires onChange and onClick if passed as props.
   * Will not fire when disabled.
   */
  onSwitch: _propTypes2.default.func,
  /**
   * Component to display when unchecked
   */
  uncheckedComponent: _propTypes2.default.node,
  /**
   * Switched state from asSwtich HOC
   * @ignore
   */
  switched: _propTypes2.default.bool.isRequired,
  /**
   * Input value. Whether checked or not.
   */
  value: _propTypes2.default.bool
};
Checkbox.defaultProps = {
  checkedComponent: _react2.default.createElement('i', { className: 'fa fa-check-square-o' }),
  uncheckedComponent: _react2.default.createElement('i', { className: 'fa fa-square-o' })
};

exports.default = (0, _helpers.asSwitch)((0, _glamorous2.default)(Checkbox)(_Checkbox.defaultStyle, _Checkbox.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Checkbox/Checkbox.js
// module id = 431
// module chunks = 0